const state = {
  expiredSession: false
}

const getters = {}

const mutations = {
  setExpiredSession (state, value) {
    state.expiredSession = value
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
